export const roomTypesList = {
    ROOM_TYPE_PENDING  : 'ROOM_TYPE_PENDING',
    ROOM_TYPE_FULFILLED: 'ROOM_TYPE_FULFILLED',
    ROOM_TYPE_REJECTED : 'ROOM_TYPE_REJECTED',
};